import { type ReactNode } from 'react';

export function MobileOverlay({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}): ReactNode {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-20 bg-black/50 md:hidden"
      onClick={onClose}
      role="presentation"
    />
  );
}
